// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file automations/min_max.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { MinMaxAutomationLineItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.MinMaxAutomationRequest
 */
export class MinMaxAutomationRequest extends Message<MinMaxAutomationRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 1;
   */
  page = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<MinMaxAutomationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MinMaxAutomationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MinMaxAutomationRequest {
    return new MinMaxAutomationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MinMaxAutomationRequest {
    return new MinMaxAutomationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MinMaxAutomationRequest {
    return new MinMaxAutomationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MinMaxAutomationRequest | PlainMessage<MinMaxAutomationRequest> | undefined, b: MinMaxAutomationRequest | PlainMessage<MinMaxAutomationRequest> | undefined): boolean {
    return proto3.util.equals(MinMaxAutomationRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.MinMaxAutomationResponse
 */
export class MinMaxAutomationResponse extends Message<MinMaxAutomationResponse> {
  /**
   * List of min-max automations
   *
   * @generated from field: repeated com.neulink.pharmacy.MinMaxAutomationLineItem automations = 1;
   */
  automations: MinMaxAutomationLineItem[] = [];

  /**
   * Total number of min-max automations available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<MinMaxAutomationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MinMaxAutomationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "automations", kind: "message", T: MinMaxAutomationLineItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MinMaxAutomationResponse {
    return new MinMaxAutomationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MinMaxAutomationResponse {
    return new MinMaxAutomationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MinMaxAutomationResponse {
    return new MinMaxAutomationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MinMaxAutomationResponse | PlainMessage<MinMaxAutomationResponse> | undefined, b: MinMaxAutomationResponse | PlainMessage<MinMaxAutomationResponse> | undefined): boolean {
    return proto3.util.equals(MinMaxAutomationResponse, a, b);
  }
}

